module.exports = __webpack_public_path__ + "static/media/bannerCurve.76191018.svg";